import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ConfirmDialogService } from '@app/common/components/confirm-dialog/confirm-dialog.service';

export function initializeDialogService() {
  return () => {
    inject(ConfirmDialogService);
  };
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
